import classNames from 'classnames';
import styles from './BusinessTable.module.scss';
import SectionTitle from '../SectionTitle/SectionTitle';

const BusinessTable = ({ data, className, isHorisontal, Icon }) => {
  const renderTableItem = (item, index) => {
    return (
      <div
        className={styles.table__elem}
        key={index}
        itemScope
        itemType='https://schema.org/ListItem'
      >
        {item}
      </div>
    );
  };

  const renderCulumns = (item, index) => {
    return (
      <div
        className={styles.table__column}
        key={index}
        itemScope
        itemType='https://schema.org/TableColumn'
      >
        <div className={styles.table__head}>{item.title}</div>
        {item?.values && (
          <div className={styles.table__items}>
            {item.values.map(renderTableItem)}
          </div>
        )}
      </div>
    );
  };

  return (
    <section
      className={classNames([
        styles.table,
        className,
        { [styles['table--horisontal']]: isHorisontal },
      ])}
      itemScope
      itemType='https://schema.org/Table'
    >
      {data?.title && (
        <SectionTitle
          titleModify={classNames([styles.table__title, 'title--medium'])}
          Icon={Icon}
        >
          {data.title}
        </SectionTitle>
      )}
      {data?.tableItems && (
        <div className={styles.table__inner}>
          {data.tableItems.map(renderCulumns)}
        </div>
      )}
    </section>
  );
};

export default BusinessTable;
